import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-83aa4ea4")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "page-break" }, null, -1)
const _hoisted_2 = { class: "init-info" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "商品名称"),
    /*#__PURE__*/_createElementVNode("th", null, "数量"),
    /*#__PURE__*/_createElementVNode("th", null, "金额")
  ])
], -1)
_popScopeId()

import { ref, watch, onMounted } from "vue"

export default /*#__PURE__*/_defineComponent({
  props: {
	initData: Array
},
  setup(__props) {

const props = __props

const pdfItem = ref<any>([])
const renderPage = (data: any) => {
	const categorizedObjects = Object.values(categorizeOrdersByPickupPoint(data, '自提点'))

	pdfItem.value = categorizedObjects.map((item: any) => {
		let obj = {
			troupe: item[0]['团长'],
			troupeName: item[0]['自提点联系人'],
			troupePhone: item[0]['自提点电话'],
			location: item[0]['自提点'],
			address: item[0]['自提点地址'],
			orderNum: 0,
			productNum: 0,
			list: [] as any
		}
		let countNum = 0
		let countPrice = 0
		obj.list = categorizeOrdersByPickupPoint(item, '商品')
		obj.list = Object.values(obj.list)
		obj.list = obj.list.map((value: any) => {
			obj.orderNum = obj.orderNum + 1
			obj.productNum = obj.productNum + Number(value['数量'])
			let num = 0
			let totalPrice = 0
			value.forEach((val: any) => {
				num += Number(val['数量'])
				totalPrice += Number(val['商品金额'])
			})
			countNum += num
			countPrice += totalPrice
			return {
				totalPrice:totalPrice.toFixed(2),
				type: value[0]['商品'],
				num,
			}
		})
		obj.list.push({
			totalPrice: countPrice.toFixed(2),
			type: '合计',
			num: countNum.toFixed(2),
		})
		return obj
	});
}

function categorizeOrdersByPickupPoint(ordersArray: any, name: string) {
	const categorizedOrders: any = {};
	for (const order of ordersArray) {
		const pickupPoint = order[name];
		if (!categorizedOrders[pickupPoint]) {
			categorizedOrders[pickupPoint] = [];
		}
		categorizedOrders[pickupPoint].push(order);
	}
	return categorizedOrders;
}
onMounted(() => {
	renderPage(props.initData)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pdfItem.value, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "pdf-item",
      key: index
    }, [
      _hoisted_1,
      _createElementVNode("h2", null, _toDisplayString(item.location), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, "自提点联系人：" + _toDisplayString(item.troupeName) + "(" + _toDisplayString(item.troupePhone) + ")", 1),
          _createElementVNode("div", null, "自提点地址：" + _toDisplayString(item.address), 1),
          _createElementVNode("div", null, "团长信息：" + _toDisplayString(item.troupe), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, "订单数：" + _toDisplayString(item.orderNum), 1)
        ])
      ]),
      _createElementVNode("table", null, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (value, idx) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: value.type
            }, [
              _createElementVNode("td", null, _toDisplayString(value.type), 1),
              _createElementVNode("td", null, _toDisplayString(value.num), 1),
              _createElementVNode("td", null, _toDisplayString(value.totalPrice), 1)
            ]))
          }), 128))
        ])
      ])
    ]))
  }), 128))
}
}

})